import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_3 = { class: "flex justify-end" }

import {TableType} from '@/utilities/enums/Enums';
import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import FilterService from "@/utilities/services/FilterService";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import {permissionColumn} from "@/AppConfig";



export default /*#__PURE__*/_defineComponent({
  __name: 'SafetyInstructionLocationsPopup',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  height: "400px",
  columns : {
    data: [
      {
        id: 'id',
        field : 'id',
        text: t('popups.locations.id'),
        sortable: true
      },
      {
        id: 'name',
        field : 'name',
        text: t('popups.locations.name'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'street',
        field : 'street',
        text: t('popups.locations.street'),
        flex   : 1,
        sortable: true,
        type: 'template',
        template: (value) => {
          if(value.record.street != null) {
						return StringHelper.xss`${value.record.street ?? ""} ${value.record.streetNumber ?? ""}`;
          } else {
            return ""
          }
        },
      },
      {
        id:'postalCode',
        field : 'postalCode',
        text: t('popups.locations.postalCode'),
        flex   : 1,
        sortable: true
      },
      {
        id:'city',
        field : 'city',
        text: t('popups.locations.city'),
        flex   : 1,
        sortable: true
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.safetyInstructionLocations], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
}

const gridConfig = reactive(useGridConfig);

const setGridData = async ()=>{
  gridStore.setStoreData(globalStore.modal.contentObject.safetyInstructionLocations);

  // apply filters
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.safetyInstructionLocations])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = globalStore.userPreferences.userHiddenColumns.some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.safetyInstructionLocations]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !permissionColumn.includes(c.id)) {
      c.show();
    }
  }

  globalStore.reorderColumns(TableType[TableType.safetyInstructionLocations]);
}

onMounted(async () => {
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
})

onBeforeUnmount(()=>{
  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(GridInputFilter), {
            gridStore: _unref(gridStore),
            hideFilterButton: true
          }, null, 8, ["gridStore"])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ])
  ]))
}
}

})